module.exports = __webpack_public_path__ + "macbook.053c215b5c27c863d85c.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/images/cards/macbook.png
// module id = ../../../../../src/assets/images/cards/macbook.png
// module chunks = 0